import { getTimestamp } from '@src/main/shared/utils/dateUtils';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const exportToExcel = async <T extends Record<string, unknown>>(
  data: T[],
  fileName: string = 'data.xlsx',
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Hoja1');

  const columns = Object.keys(data[0]).map((key) => ({ header: key, key }));

  worksheet.columns = columns;

  data.forEach((item) => {
    worksheet.addRow(item);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });

  const timestamp = getTimestamp();
  saveAs(blob, `${fileName}_${timestamp}.xlsx`);
};
